export default __webpack_public_path__ + "static/media/non-household-4.d8036b54.jpg";